import React, {
    useState,
    useEffect
}
from "react";

import {
    functions
}
from "../constants/common-functions";

import {
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";

import {
    faMapLocationDot,
    faXmark
}
from "@fortawesome/free-solid-svg-icons";

import bluepin
from "../../images/bluepin.png";

import darkbluepin
from "../../images/darkbluepin.png";

import orangepin
from "../../images/orangepin.png";

import redpin
from "../../images/redpin.png";

import purplepin
from "../../images/purplepin.png";

import blackpin
from "../../images/blackpin.png";

import yellowpin
from "../../images/yellowpin.png";

import "./mapkey.css";


export default function MapKey(
{
    id,
    keyDisplay,
    setKeyDisplay,
    selectedFacilityTypeMapId,
    setSelectedFacilityTypeMapId,
    isMobile = false
})
{

    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [mapPins, setMapPins] =
        useState([]);

    const [mobileKeyOpen, setMobileKeyOpen] =
        useState(false);


    //========================================================
    // Load map pins
    //========================================================

    useEffect(
        function()
        {

            functions.getArrayFromAjax(
                "/resolutionsoftwareplatform/facilitytypemaps?siteId=-100",
                populateMapPins,
                null
            );

        },
        []
    );


    //--------------------------------------------------------
    // Populate pins
    //--------------------------------------------------------

    const populateMapPins =
        function(results)
        {

            const tempMapPins = [];

            for(
                let i = 0;
                i < results.length;
                i++
            )
            {

                let pin =
                    blackpin;

                if(results[i].icon === "bluepin")
                {

                    pin =
                        bluepin;

                }
                else if(
                    results[i].icon ===
                    "darkbluepin"
                )
                {

                    pin =
                        darkbluepin;

                }
                else if(
                    results[i].icon ===
                    "orangepin"
                )
                {

                    pin =
                        orangepin;

                }
                else if(
                    results[i].icon ===
                    "redpin"
                )
                {

                    pin =
                        redpin;

                }
                else if(
                    results[i].icon ===
                    "purplepin"
                )
                {

                    pin =
                        purplepin;

                }
                else if(
                    results[i].icon ===
                    "yellowpin"
                )
                {

                    pin =
                        yellowpin;

                }

                tempMapPins.push(
                {
                    id:
                        results[i].id,

                    name:
                        results[i].name,

                    icon:
                        pin
                });

            }

            setMapPins(
                tempMapPins
            );

        };


    //========================================================
    // Events
    //========================================================

    const handleMapPinClick =
        function(item)
        {

            if(
                item.id !==
                selectedFacilityTypeMapId
            )
            {

                setSelectedFacilityTypeMapId(
                    item.id
                );

            }
            else
            {

                setSelectedFacilityTypeMapId(
                    "-100"
                );

            }


            //------------------------------------------------
            // Close mobile key after selection
            //------------------------------------------------

            if(isMobile)
            {

                setMobileKeyOpen(
                    false
                );

            }

        };


    const toggleMobileKey =
        function()
        {

            setMobileKeyOpen(
                function(current)
                {

                    return !current;

                }
            );

        };


    //========================================================
    // Desktop styles
    //========================================================

    const thisContainer =
    {
        display:
            "flex",

        width:
            "calc(100% - 20px)",

        height:
            "100%",

        flexWrap:
            "wrap",

        marginLeft:
            "20px"
    };


    const keyContainer =
    {
        display:
            "flex",

        margin:
            "10px",

        alignItems:
            "center",

        minWidth:
            "100px"
    };


    const keyIcon =
    {
        display:
            "flex",

        width:
            "20px",

        marginRight:
            "10px",

        cursor:
            "pointer"
    };


    const keyLabel =
    {
        display:
            "flex",

        color:
            "black",

        fontSize:
            "12px"
    };


    //========================================================
    // Mobile styles
    //========================================================

    const mobileButton =
    {
        position:
            "absolute",

        left:
            "14px",

        bottom:
            "18px",

        width:
            "46px",

        height:
            "46px",

        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center",

        borderRadius:
            "50%",

        background:
            "linear-gradient(180deg, #1f2937 0%, #111827 100%)",

        border:
            "1px solid rgba(255,255,255,0.45)",

        boxShadow:
            `
                inset 0 1px 2px rgba(255,255,255,0.35),
                inset 0 -2px 4px rgba(0,0,0,0.25),
                0 5px 14px rgba(0,0,0,0.25)
            `,

        color:
            "#ffffff",

        fontSize:
            "18px",

        cursor:
            "pointer",

        zIndex:
            1000
    };


    const mobilePanel =
    {
        position:
            "absolute",

        left:
            "14px",

        bottom:
            "74px",

        width:
            "230px",

        maxHeight:
            "300px",

        overflowY:
            "auto",

        padding:
            "10px",

        boxSizing:
            "border-box",

        background:
            "rgba(255,255,255,0.88)",

        backdropFilter:
            "blur(18px)",

        WebkitBackdropFilter:
            "blur(18px)",

        border:
            "1px solid rgba(255,255,255,0.75)",

        borderRadius:
            "14px",

        boxShadow:
            "0 10px 30px rgba(0,0,0,0.20)",

        zIndex:
            999
    };


    const mobileHeader =
    {
        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "space-between",

        height:
            "32px",

        padding:
            "0 4px 7px 5px",

        marginBottom:
            "4px",

        borderBottom:
            "1px solid rgba(38,49,61,0.10)"
    };


    const mobileHeaderTitle =
    {
        display:
            "flex",

        alignItems:
            "center",

        gap:
            "7px",

        fontSize:
            "13px",

        fontWeight:
            "700",

        color:
            "#26313D"
    };


    const mobileClose =
    {
        width:
            "28px",

        height:
            "28px",

        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center",

        borderRadius:
            "50%",

        color:
            "#66717D",

        cursor:
            "pointer"
    };


    const mobileKeyRow =
        function(item)
        {

            const selected =
                item.id ===
                selectedFacilityTypeMapId;

            return {

                display:
                    "flex",

                alignItems:
                    "center",

                width:
                    "100%",

                minHeight:
                    "44px",

                padding:
                    "6px 9px",

                boxSizing:
                    "border-box",

                marginBottom:
                    "3px",

                borderRadius:
                    "9px",

                background:
                    selected
                        ?
                        "rgba(90,155,214,0.16)"
                        :
                        "rgba(255,255,255,0.25)",

                border:
                    selected
                        ?
                        "1px solid rgba(90,155,214,0.30)"
                        :
                        "1px solid transparent",

                cursor:
                    "pointer"
            };

        };


    const mobilePin =
    {
        width:
            "18px",

        height:
            "25px",

        objectFit:
            "contain",

        marginRight:
            "11px",

        flexShrink:
            0
    };


    const mobileLabel =
    {
        flexGrow:
            1,

        color:
            "#26313D",

        fontSize:
            "12px",

        fontWeight:
            "500"
    };


    const selectedIndicator =
    {
        width:
            "7px",

        height:
            "7px",

        borderRadius:
            "50%",

        background:
            "#5A9BD6",

        marginLeft:
            "8px"
    };


    //========================================================
    // Mobile
    //========================================================

    if(isMobile)
    {

        return (

            <>

                {/* ==========================================
                    KEY PANEL
                ========================================== */}

                {
                    mobileKeyOpen
                    &&
                    <div style={mobilePanel}>

                        <div style={mobileHeader}>

                            <div style={mobileHeaderTitle}>

                                <FontAwesomeIcon
                                    icon={faMapLocationDot}
                                />

                                Map Key

                            </div>


                            <div
                                style={mobileClose}
                                onClick={
                                    function()
                                    {

                                        setMobileKeyOpen(
                                            false
                                        );

                                    }
                                }
                            >

                                <FontAwesomeIcon
                                    icon={faXmark}
                                />

                            </div>

                        </div>


                        {
                            mapPins.map(
                                function(item)
                                {

                                    const selected =
                                        item.id ===
                                        selectedFacilityTypeMapId;

                                    return (

                                        <div
                                            key={item.id}
                                            style={
                                                mobileKeyRow(
                                                    item
                                                )
                                            }
                                            onClick={
                                                function()
                                                {

                                                    handleMapPinClick(
                                                        item
                                                    );

                                                }
                                            }
                                        >

                                            <img
                                                src={item.icon}
                                                alt=""
                                                style={mobilePin}
                                            />

                                            <div style={mobileLabel}>

                                                {item.name}

                                            </div>


                                            {
                                                selected
                                                &&
                                                <div
                                                    style={
                                                        selectedIndicator
                                                    }
                                                />
                                            }

                                        </div>

                                    );

                                }
                            )
                        }

                    </div>
                }


                {/* ==========================================
                    KEY BUTTON
                ========================================== */}

                <div
                    style={mobileButton}
                    onClick={toggleMobileKey}
                >

                    <FontAwesomeIcon
                        icon={faMapLocationDot}
                    />

                </div>

            </>

        );

    }


    //========================================================
    // Desktop
    //========================================================

    const mapPinDisplay =
        mapPins.map(
            function(item)
            {

                return (

                    <div
                        key={item.id}
                        style={keyContainer}
                    >

                        <img
                            src={item.icon}
                            alt=""
                            style={keyIcon}
                            onClick={
                                function()
                                {

                                    handleMapPinClick(
                                        item
                                    );

                                }
                            }
                        />

                        <div style={keyLabel}>

                            {item.name}

                        </div>

                    </div>

                );

            }
        );


    return (

        <div
            className="mapkey"
            style={{
                display:
                    keyDisplay
                        ?
                        "flex"
                        :
                        "none"
            }}
        >

            <div style={thisContainer}>

                {mapPinDisplay}

            </div>

        </div>

    );

}